const USER_THEME_KEY = 'chatyx_user_theme';

export function getUserTheme() {
  try {
    const value = localStorage.getItem(USER_THEME_KEY);
    return value === 'light' || value === 'dark' ? value : null;
  } catch (e) {
    return null;
  }
}

export function setUserTheme(theme) {
  try {
    localStorage.setItem(USER_THEME_KEY, theme);
  } catch (e) {
    // ignore storage errors
  }
}

export function clearUserTheme() {
  try {
    localStorage.removeItem(USER_THEME_KEY);
  } catch (e) {
    // ignore storage errors
  }
}

export function resolveTheme(ownerTheme, userOverride) {
  if (userOverride === 'dark' || userOverride === 'light') return userOverride;
  if (ownerTheme === 'dark') return 'dark';
  if (ownerTheme === 'light') return 'light';
  if (typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return 'dark';
  }
  return 'light';
}

function applyThemeClass(el, resolved) {
  if (resolved === 'dark') {
    el.classList.add('theme-dark');
  } else {
    el.classList.remove('theme-dark');
  }
}

export function createThemeController(el, ownerTheme) {
  function getResolved() {
    return resolveTheme(ownerTheme, getUserTheme());
  }

  function apply() {
    applyThemeClass(el, getResolved());
  }

  function toggle() {
    const current = getResolved();
    const next = current === 'dark' ? 'light' : 'dark';
    setUserTheme(next);
    apply();
    return next;
  }

  // Change the owner-configured theme at runtime (used by the live dashboard
  // preview so a theme switch is applied in place, without re-mounting).
  function setOwnerTheme(next) {
    ownerTheme = next;
    apply();
  }

  apply();

  if (typeof window !== 'undefined' && window.matchMedia) {
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = () => {
      if (ownerTheme === 'auto' && !getUserTheme()) {
        apply();
      }
    };
    if (mql.addEventListener) {
      mql.addEventListener('change', handler);
    } else if (mql.addListener) {
      mql.addListener(handler);
    }
  }

  return { toggle, getResolved, apply, setOwnerTheme };
}
